import React, { useState, useRef } from 'react'
import classnames from 'classnames/bind'

import { Text } from 'components/typo'

import useUnderline from 'hooks/useUnderline'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const TabText = ({ children, className }) => {
  return (
    <Text className={className} size="small" theme="dark" tag="span">
      {children}
    </Text>
  )
}

const Tab = ({ name, isActive, onClick }) => {
  const [hover, setHover] = useState(false)

  const lineRef = useRef()
  useUnderline(isActive || hover, { ref: lineRef })

  return (
    <div
      className={cx(css.text, { isActive })}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <TabText className={css.active}>{name}</TabText>
      <TabText className={css.inactive}>{name}</TabText>
      <div className={css.lineContainer}>
        <div ref={lineRef} className={css.line} />
      </div>
    </div>
  )
}

const Tabs = ({ active, categories, onClick }) => {
  return (
    <div className={css.Tabs}>
      <div className={css.container}>
        {categories.map(({ name }, i) => {
          const isActive = active === i

          return (
            <Tab
              key={`tab-${name}-${i}`}
              name={name}
              onClick={() => onClick(i)}
              isActive={isActive}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Tabs
